import { BaseSlideAppService } from '../../../core/services/slide-app-service.base';

/**
 * 备注视图
 */
export class SubsidiaryDataSlideAppService extends BaseSlideAppService {
    protected init() {}
}
